/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import React from 'react'
import { RouteComponentProps, Route, Link } from 'react-router-dom'
import { observer, Observer } from 'mobx-react'
import { injectProperty, container } from '../../arc/configuration/ServiceLocator'
import { Spinner, Input, Label, Row, Col, Button, Modal, ModalBody, Form, ModalFooter, ModalHeader } from 'reactstrap'
import './Batches.scss'
import { IUserSessionStateManager } from '../../arc/services/UserSessionStateManager/contracts'
import { IBatchesStateManager, ICoverageDiscoveryBatchHistoryGridFilterCriteria, ITransactionStatus, IOwnerUser, ICoverageDiscoveryBatchHistoryGrid, ICoverageDiscoveryBatchHistoryGridBatchData } from '../../services/BatchesStateManager/contracts'
import { IBatchesApiClient } from '../../services/BatchesApiClient/contracts'
import 'react-datepicker/dist/react-datepicker.css'
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone, PaginationTotalStandalone } from 'react-bootstrap-table2-paginator'
import filterFactory from 'react-bootstrap-table2-filter'
import BootstrapTable from 'react-bootstrap-table-next'
import 'react-datepicker/dist/react-datepicker.css'
import { TopPart } from '../TopPart/TopPart'

import DatePicker from 'react-datepicker'
import Moment from 'react-moment'
import overlayFactory from 'react-bootstrap-table2-overlay'
import { ImportBatchUI } from '../ImportBatchUI/ImportBatchUI'
import { IImportBatchUIStateManager } from '../../services/ImportBatchUIStateManager/contracts'

import fileSaver from 'file-saver'
import { IExportRequest } from '../../services/ExportRequestApiClient/contracts'
import moment from 'moment'
import { ValidationMessage, MessageTypes } from '../ValidationMessage/ValidationMessage'

import MaskedInput from 'react-text-mask'
import { SettingsManager } from '../../configuration/SettingsManager'
import { TransactionStatus } from '../../configuration/Enums/TransactionStaus'
import { BatchRunStatus } from '../../configuration/Enums/BatchRunStatus'
import { BatchInfo } from './BatchInfo/BatchInfo'
export interface IBatchesProps extends RouteComponentProps<any> {
	BatchesStateManager: IBatchesStateManager
	usersessionStateManager: IUserSessionStateManager
	ImportBatchUIStateManager: IImportBatchUIStateManager
}

interface IBatchesState {
	isDataLoading: boolean
	IsPageLoading: boolean
	typingTimeout: any
	isSearching: boolean
	isOwnerLoadedForFilter: any
	isStatusLoadedForFilter: any
	owners: any
	statuses: any
	transactionDate: any
	isTransactionDateSearched: any
	selectedRunDateRangeId: any
	modalForExportJob: any
	fadeForExportJobModal: any
	modalForBatchExport: any
	fadeForBatchExport: any
	modalForDelete: any
	fadeForDelete: any
	imageSrc: any
	modalForFinalMessage: any
	fadeForFinalMessage: any
	IsStatusFilterApplied: any
	IsOwnerFilterApplied: any
	batchNameForDeleteModal: any
	requestDateForDeleteModal: any
	selectedBatchIdForDelete: any
	selectedBatchRunIdForDelete: any
	batchRunIdForExportJobModal: number
	batchNameForExportJobModal: string
	checkDateTime: any
	errorMessage: string
	showErrorMessage: boolean
	deleteSuccessMessage: string
	showDeleteSuccessMessage: any
	allOnPageSelectedForOwner: any
	allOnPageSelectedFortransactionStatus: any
	isFiltersLoadedFirstTime: any
}

type TableChangeState = {
	page: number
	sizePerPage: number
	sortField: string
	sortOrder: string
}

@observer
export class Batches extends React.Component<IBatchesProps, IBatchesState> {
	@injectProperty('IBatchesApiClient')
	public readonly BatchesApiClient!: IBatchesApiClient

	private transactionDateTextboxRef: React.RefObject<HTMLInputElement>

	setAsyncState = (newState: IBatchesState): Promise<void> => new Promise(resolve => this.setState(newState, resolve))
	private tableHeight: number
	private spinnerHeight: number

	constructor(props: Readonly<IBatchesProps>) {
		super(props)
		this.state = {
			isDataLoading: false,
			IsPageLoading: true,
			typingTimeout: null,
			isSearching: false,
			isOwnerLoadedForFilter: false,
			isStatusLoadedForFilter: false,
			owners: [],
			statuses: [],
			transactionDate: null,
			isTransactionDateSearched: false,
			selectedRunDateRangeId: 0,
			modalForExportJob: false,
			fadeForExportJobModal: false,
			modalForBatchExport: false,
			fadeForBatchExport: false,
			imageSrc: ['icon-drop-pending-sm', 'icon-drop-active-sm', 'icon-drop-failed-sm', 'icon-drop-missing-sm', 'icon-drop-processing-sm'],
			modalForFinalMessage: false,
			fadeForFinalMessage: false,
			IsStatusFilterApplied: false,
			IsOwnerFilterApplied: false,
			modalForDelete: false,
			fadeForDelete: false,
			batchNameForDeleteModal: '',
			requestDateForDeleteModal: '',
			selectedBatchIdForDelete: 0,
			selectedBatchRunIdForDelete: 0,
			batchRunIdForExportJobModal: 0,
			batchNameForExportJobModal: '',
			checkDateTime: null,
			errorMessage: '',
			showErrorMessage: false,
			deleteSuccessMessage: '',
			showDeleteSuccessMessage: false,
			allOnPageSelectedForOwner: false,
			allOnPageSelectedFortransactionStatus: false,
			isFiltersLoadedFirstTime: false,
		}
		this.tableHeight = 5
		this.spinnerHeight = 5
		this.transactionDateTextboxRef = React.createRef()
	}

	componentDidMount(): void {
		this.setIsPageLoadState(false)
		this.props.BatchesStateManager.loadRunDatesRange()
		this.toggleValidationMessageForDelete = this.toggleValidationMessageForDelete.bind(this)
		this.props.BatchesStateManager.batchHistoryGridCriteria.searchTerm.runDate = undefined
		this.props.BatchesStateManager.batchHistoryGridCriteria.searchTerm.ownerUsers = []
		this.props.BatchesStateManager.batchHistoryGridCriteria.searchTerm.transactionStatuses = []

		if (this.props.BatchesStateManager.intervalId !== null) {
			clearInterval(this.props.BatchesStateManager.intervalId)
		}

		if (this.state.checkDateTime === null) {
			this.props.BatchesStateManager.intervalId = window.setInterval(() => {
				if (this.state.isDataLoading === false) {
					this.props.ImportBatchUIStateManager.isRequestRaisedForImport === false &&
						this.props.BatchesStateManager.setBatchHistoryGridCriteria(
							{
								...this.props.BatchesStateManager.batchHistoryGridCriteria,
							},
							true,
						)
							.then(() => {
								this.setState({ isDataLoading: false })
							})
							.catch(error => {
								this.setState({ isDataLoading: false })
								alert(error)
							})
				}
			}, SettingsManager.COVERAGE_DISCOVERY_BATCHES_INTERVAL_IN_MILLISECONDS)
		} else {
			if (Math.round(this.state.checkDateTime) - Math.round(new Date().getMilliseconds()) > SettingsManager.COVERAGE_DISCOVERY_BATCHES_INTERVAL_IN_MILLISECONDS) {
				this.props.BatchesStateManager.intervalId = window.setInterval(() => {
					if (this.state.isDataLoading === false) {
						this.props.ImportBatchUIStateManager.isRequestRaisedForImport === false &&
							this.props.BatchesStateManager.setBatchHistoryGridCriteria(
								{
									...this.props.BatchesStateManager.batchHistoryGridCriteria,
								},
								true,
							)
								.then(() => {
									this.setState({ isDataLoading: false })
								})
								.catch(error => {
									this.setState({ isDataLoading: false })
									alert(error)
								})
					}
				}, SettingsManager.COVERAGE_DISCOVERY_BATCHES_INTERVAL_IN_MILLISECONDS)
			}
		}

		this.toggleValidationMessageShow = this.toggleValidationMessageShow.bind(this)
	}

	componentWillUnmount(): void {
		if (this.props.BatchesStateManager.intervalId !== null) {
			clearInterval(this.props.BatchesStateManager.intervalId)
		}
	}

	toggleValidationMessageShow(): void {
		this.setState({
			showErrorMessage: !this.state.showErrorMessage,
			errorMessage: '',
		})
	}

	toggleValidationMessageForDelete(): void {
		this.setState({
			showDeleteSuccessMessage: !this.state.showDeleteSuccessMessage,
			deleteSuccessMessage: '',
		})
	}

	handleSearch(): Promise<void> {
		this.tableHeight = document.getElementsByClassName('dataTable')[0].clientHeight
		if (this.props.BatchesStateManager.batchHistoryGridResults.total === 0) {
			this.tableHeight = this.tableHeight - 15
		}
		this.spinnerHeight = document.getElementsByClassName('dataTable')[0].clientHeight - 65
		this.setState({
			isDataLoading: true,
			checkDateTime: new Date().getMilliseconds(),
			showDeleteSuccessMessage: false,
		})
		const searchTerm: ICoverageDiscoveryBatchHistoryGridFilterCriteria = {
			ownerUsers: this.props.BatchesStateManager.availableOwners.filter((x: { isSelected: any }) => x.isSelected),
			transactionStatuses: this.props.BatchesStateManager.availableTransactionStatuses.filter((x: { isSelected: any }) => x.isSelected),
			runDate: undefined,
		}

		if (this.transactionDateTextboxRef.current && this.transactionDateTextboxRef.current.valueAsDate) {
			const curTime = this.transactionDateTextboxRef.current.valueAsDate
			searchTerm.runDate = curTime
		}

		this.setState({
			isSearching: true,
			IsStatusFilterApplied: this.props.BatchesStateManager.availableTransactionStatuses.some((x: { isSelected: any }) => x.isSelected),
			IsOwnerFilterApplied: this.props.BatchesStateManager.availableOwners.some((x: { isSelected: any }) => x.isSelected),
			isTransactionDateSearched: searchTerm.runDate !== null && typeof searchTerm.runDate !== 'undefined' ? true : false,
		})
		if (this.state.typingTimeout) {
			clearTimeout(this.state.typingTimeout)
		}
		return new Promise(resolve => {
			this.setState({
				typingTimeout: setTimeout(() => {
					resolve(
						this.props.BatchesStateManager.setBatchHistoryGridCriteria({ ...this.props.BatchesStateManager.batchHistoryGridCriteria, searchTerm: searchTerm, page: 1, dateRange: this.state.selectedRunDateRangeId }, false)
							.then(() => {
								this.setState({
									isSearching: false,
									isDataLoading: false,
								})
							})
							.catch(() => {
								this.setState({ isSearching: false, isDataLoading: false })
							}),
					)
				}, 300),
			})
		})
	}

	renderImportBatchUI(): any {
		const storeImportBatch = container.get<IImportBatchUIStateManager>('IImportBatchUIStateManager')
		return <ImportBatchUI {...this.props} ImportBatchUIStateManager={storeImportBatch} />
	}

	setIsPageLoadState(val: boolean): void {
		this.setState({
			IsPageLoading: val,
		})
	}

	NoDataIndication = (): any => <div className="no-data">{this.state.isDataLoading === true ? <></> : <span>No result found</span>}</div>

	handleTransactionDateChange = (e: Date): void => {
		this.setState({ transactionDate: e !== null ? new Date(e) : null, showDeleteSuccessMessage: false })
		if (this.transactionDateTextboxRef.current !== null) this.transactionDateTextboxRef.current.valueAsDate = e !== null ? e : null
		if (e === null) return
		if (e > new Date()) {
			alert('Transaction date value cannot be a date in the future')
			this.setState({ transactionDate: null })
			if (this.transactionDateTextboxRef.current !== null) this.transactionDateTextboxRef.current.valueAsDate = null
			return
		}
		setTimeout(() => this.CheckManualEnteredDateForTransaction(), 1000)
	}

	CheckManualEnteredDateForTransaction(): void {
		const selectedDate = document.getElementById('runDate') as HTMLInputElement
		if (selectedDate != null && selectedDate.value != null && selectedDate.value.match(SettingsManager.DATE_REGULAR_EXPRESSION) === null) {
			alert(selectedDate.value + ' is not valid Date')
			this.setState({ transactionDate: null })
			if (this.transactionDateTextboxRef.current !== null) this.transactionDateTextboxRef.current.valueAsDate = null
			return
		}
	}

	changeStateOfCheckboxesToIntitalForStatus(): void {
		this.props.BatchesStateManager.availableTransactionStatuses.forEach((element: { isSelected: boolean }) => {
			element.isSelected = false
		})
		this.setState({
			allOnPageSelectedFortransactionStatus: false,
		})
	}

	changeStateOfCheckboxesToIntitalForOwner(): void {
		this.props.BatchesStateManager.availableOwners.forEach((element: { isSelected: boolean }) => {
			element.isSelected = false
		})
		this.setState({
			allOnPageSelectedForOwner: false,
		})
	}

	changeStateOfCheckboxesToIntital(): void {
		this.changeStateOfCheckboxesToIntitalForStatus()
		this.changeStateOfCheckboxesToIntitalForOwner()
	}

	showOrHideClearAll(): any {
		const transactionDateSearched = this.state.isTransactionDateSearched
		if (!transactionDateSearched && !this.state.IsOwnerFilterApplied && !this.state.IsStatusFilterApplied) {
			return null
		} else {
			if (transactionDateSearched || this.state.IsOwnerFilterApplied || this.state.IsStatusFilterApplied) {
				return (
					<div id="clearAllForBatches">
						<span onClick={(): void => this.clearAll()}>Clear All</span>
					</div>
				)
			}
		}
		return
	}

	clearAll(): any {
		if (this.transactionDateTextboxRef.current != null) this.transactionDateTextboxRef.current.valueAsDate = null
		$('.batchesHistory').scrollTop(0)
		this.setAsyncState({
			transactionDate: null,
			isTransactionDateSearched: false,
			selectedRunDateRangeId: 0,
		} as IBatchesState)
			.then(() => this.changeStateOfCheckboxesToIntital())
			.then(() => this.handleSearch())
			.catch(err => console.error(err))
	}

	closeDateTransactionPopupOnTab(e: KeyboardEvent): void {
		if (e.key === 'Tab') {
			e.preventDefault()
			const btnFilterForBatches = document.getElementById('btnFilterForBatches')
			if (btnFilterForBatches !== null) {
				const datePicker = this.transactionDateTextboxRef.current as DatePicker
				if (datePicker !== null) {
					datePicker.setOpen(false)
				}
				btnFilterForBatches.focus()
			}
		}
	}

	setTransactionDate(e: Date | null): void {
		this.setState({ transactionDate: e !== null ? new Date(e) : null })
		if (this.transactionDateTextboxRef.current !== null) this.transactionDateTextboxRef.current.valueAsDate = e !== null ? e : null
	}
	renderDate(date: Date): Date {
		return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000)
	}

	handleTableChange = (type: string, args: TableChangeState): void => {
		this.spinnerHeight = typeof document.getElementsByClassName('dataTable')[0] !== 'undefined' ? document.getElementsByClassName('dataTable')[0].clientHeight - 65 : this.spinnerHeight
		this.tableHeight = typeof document.getElementsByClassName('dataTable')[0] !== 'undefined' ? document.getElementsByClassName('dataTable')[0].clientHeight : this.tableHeight
		if (this.props.BatchesStateManager.batchHistoryGridResults.total === 0) {
			this.tableHeight = this.tableHeight - 15
		}
		this.setState({
			isDataLoading: true,
			checkDateTime: new Date().getMilliseconds(),
		})
		this.props.BatchesStateManager.setBatchHistoryGridCriteria(
			{
				sortOrder: args.sortOrder ? args.sortOrder : this.props.BatchesStateManager.batchHistoryGridCriteria.sortOrder,
				sortField: args.sortField ? args.sortField : this.props.BatchesStateManager.batchHistoryGridCriteria.sortField,
				page: args.page,
				sizePerPage: args.sizePerPage,
				searchTerm: this.props.BatchesStateManager.batchHistoryGridCriteria.searchTerm,
				dateRange: this.props.BatchesStateManager.batchHistoryGridCriteria.dateRange,
			},
			false,
		)
			.then(() => {
				this.setState({ isDataLoading: false })
				if (this.state.isFiltersLoadedFirstTime === false) {
					if (this.state.isStatusLoadedForFilter === false) {
						this.props.BatchesStateManager.loadAvailableTransactionStatuses()
							.catch(error => {
								alert(error)
								this.setState({
									isFiltersLoadedFirstTime: true,
								})
							})
							.then(() => {
								this.setState({
									allOnPageSelectedFortransactionStatus: this.getAllSelectedForStatus(),
									isStatusLoadedForFilter: true,
								})
							})
							.then(() => {
								if (this.state.isOwnerLoadedForFilter === false) {
									this.props.BatchesStateManager.loadAvailableOwners()
										.catch(error => {
											alert(error)
											this.setState({
												isFiltersLoadedFirstTime: true,
											})
										})
										.then(() => {
											this.setState({
												allOnPageSelectedForOwner: this.getAllSelectedForOwner(),
												isOwnerLoadedForFilter: true,
											})
										})
								}
							})
					}
				}
			})
			.then(() => {
				this.setState({
					isFiltersLoadedFirstTime: true,
				})
			})
			.catch(error => {
				this.setState({ isDataLoading: false })
				alert(error)
			})
	}

	getAllSelectedForStatus(): boolean {
		const countSelected = this.props.BatchesStateManager.availableTransactionStatuses.filter(item => item.isSelected).length
		const totalCount = this.props.BatchesStateManager.availableTransactionStatuses.length
		return countSelected === totalCount
	}

	getAllSelectedForOwner(): boolean {
		const countSelected = this.props.BatchesStateManager.availableOwners.filter(item => item.isSelected).length
		const totalCount = this.props.BatchesStateManager.availableOwners.length
		return countSelected === totalCount
	}

	handleTransactionStatusSelectedChange(status: ITransactionStatus, value: boolean): void {
		this.props.BatchesStateManager.setTransactionStatusValue(status.id, value)
		status.isSelected = value
		this.setState({ allOnPageSelectedFortransactionStatus: this.getAllSelectedForStatus(), showDeleteSuccessMessage: false })
	}

	handleOwnerSelectedChange(owner: IOwnerUser, value: boolean): void {
		this.props.BatchesStateManager.setOwnerValue(owner.id, value)
		owner.isSelected = value
		this.setState({ allOnPageSelectedForOwner: this.getAllSelectedForOwner(), showDeleteSuccessMessage: false })
	}

	handleOwnerSelectAll(): void {
		const allSelected: boolean = this.state.allOnPageSelectedForOwner
		if (allSelected) {
			for (const row of this.props.BatchesStateManager.availableOwners) {
				this.handleOwnerSelectedChange(row, false)
			}
		} else {
			for (const row of this.props.BatchesStateManager.availableOwners) {
				if (!row.isSelected) this.handleOwnerSelectedChange(row, true)
			}
		}
	}

	handletransactionStatusSelectAll(): void {
		const allSelected: boolean = this.state.allOnPageSelectedFortransactionStatus
		if (allSelected) {
			for (const row of this.props.BatchesStateManager.availableTransactionStatuses) {
				this.handleTransactionStatusSelectedChange(row, false)
			}
		} else {
			for (const row of this.props.BatchesStateManager.availableTransactionStatuses) {
				if (!row.isSelected) this.handleTransactionStatusSelectedChange(row, true)
			}
		}
	}

	renderOwner = (): any => {
		if (this.state.isOwnerLoadedForFilter) {
			return !this.props.BatchesStateManager.availableOwners || this.props.BatchesStateManager.availableOwners.length === 0 ? (
				<div id="batchMessage">No owner was found. Please contact administrator</div>
			) : (
				<div className="batchesHistory">
					<div id="selectAllForOwners" style={{ marginTop: '10px' }}>
						<label id="npiName">Owner</label>
						<span className="anchorTagForBatchesHistory" style={{ marginLeft: '90px', fontSize: '11px' }} onClick={(): void => this.handleOwnerSelectAll()}>
							{this.state.allOnPageSelectedForOwner ? 'Unselect All' : 'Select All'}
						</span>
					</div>

					<div id="divForCheckBox" style={{ marginLeft: '26px' }}>
						{this.props.BatchesStateManager.availableOwners.map(c => {
							return (
								<Row key={c.id}>
									<input type="checkbox" name="checkOwner[]" checked={c.isSelected} id="chkNpi" onChange={(e: any): void => this.handleOwnerSelectedChange(c, e.target.checked)} value={c.id} />
									&nbsp;&nbsp;{c.name}
								</Row>
							)
						})}
					</div>
				</div>
			)
		}
	}

	/*** On Export Button Click  */
	onExportToExcel(batchRunId: number, batchName: string): void {
		this.spinnerHeight = typeof document.getElementsByClassName('dataTable')[0] !== 'undefined' ? document.getElementsByClassName('dataTable')[0].clientHeight - 65 : this.spinnerHeight
		this.tableHeight = typeof document.getElementsByClassName('dataTable')[0] !== 'undefined' ? document.getElementsByClassName('dataTable')[0].clientHeight : this.tableHeight
		this.setState({
			isDataLoading: true,
		})

		this.props.BatchesStateManager.isDataLoadingForInterval = false
		this.props.BatchesStateManager.getTransactionReport({ batchRunId: batchRunId } as IExportRequest)
			.then((response: any) => {
				const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
				fileSaver.saveAs(blob, this.getExportReportFileName(batchName))
				this.setState({
					isDataLoading: false,
				})
			})
			.catch((error: any) => {
				this.setState({
					showErrorMessage: true,
					errorMessage: error.toString(),
					isDataLoading: false,
				})
			})
	}

	renderTransactionDate = (): any => {
		return (
			<div className="batchesHistoryTransactionDate">
				<div id="selectAllForOwners">
					<label id="npiName" style={{ marginTop: '20px', marginBottom: '20px' }}>
						Transaction Date
					</label>
				</div>
				<div id="bodyContentForFilterBatchesHistoryTextbox">
					<div id="textBoxForBatchesFilterHistory" style={{ marginLeft: '15px' }}>
						<div style={{ width: '120px' }}>Batch Run Within:</div>
						<div>
							<Input type="select" id="dropDownForDateRangeFilter" className="non-uniform" name="dropdownDates" value={this.state.selectedRunDateRangeId} onChange={(event: React.ChangeEvent<HTMLInputElement>): void => this.loadSelectedDateById(event)}>
								{typeof this.props.BatchesStateManager.runDateDropdownList !== 'undefined' &&
									this.props.BatchesStateManager.runDateDropdownList.map(c => {
										return (
											<option key={c.id} value={c.id} style={{ fontSize: '13px' }}>
												{c.selectionText}
											</option>
										)
									})}
							</Input>
						</div>
						of
						<div style={{ marginTop: '10px' }}>
							<DatePicker ref={this.transactionDateTextboxRef} onKeyDown={this.closeDateTransactionPopupOnTab} selected={this.state.transactionDate} className="dob input-110 float-left rounded-lg" placeholderText="Date(mm/dd/yyyy)" showYearDropdown showMonthDropdown peekNextMonth dropdownMode="select" name="rundate" id="rundate" customInput={<MaskedInput type="text" mask={[/[01]/, /\d/, '/', /[0-3]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]} />} onChange={(e): void => this.handleTransactionDateChange(e)} popperPlacement="bottom" />
						</div>
					</div>
				</div>
			</div>
		)
	}

	renderStatus = (): any => {
		if (this.state.isStatusLoadedForFilter) {
			return !this.props.BatchesStateManager.availableTransactionStatuses || this.props.BatchesStateManager.availableTransactionStatuses.length === 0 ? (
				<div id="batchMessage">No status was found. Please contact administrator</div>
			) : (
				<div className="batchesHistoryTransactionStatus">
					<div id="selectAllForOwners" style={{ marginTop: '10px' }}>
						<label id="npiName">Transaction Status</label>
						<span className="anchorTagForBatchesHistory" style={{ marginLeft: '19px', fontSize: '11px' }} onClick={(): void => this.handletransactionStatusSelectAll()}>
							{this.state.allOnPageSelectedFortransactionStatus ? 'Unselect All' : 'Select All'}
						</span>
					</div>
					<div id="divForCheckBox" style={{ marginLeft: '26px' }}>
						{this.props.BatchesStateManager.availableTransactionStatuses.map(c => {
							return (
								<Row key={c.id}>
									<input type="checkbox" name="checkStatus[]" checked={c.isSelected} id="chkNpi" onChange={(e: React.ChangeEvent<HTMLInputElement>): void => this.handleTransactionStatusSelectedChange(c, e.target.checked)} value={c.id} />
									<img src={`img/${this.state.imageSrc[c.id - 1]}.png`} alt={c.name} style={{ marginLeft: '10px' }}></img>&nbsp;&nbsp;&nbsp;&nbsp;{c.name}
								</Row>
							)
						})}
					</div>
				</div>
			)
		}
	}

	loadSelectedDateById(event: React.ChangeEvent<HTMLInputElement>): void {
		this.setState({
			selectedRunDateRangeId: event.target.value,
			showDeleteSuccessMessage: false,
		})
	}

	toggleModalPopupOnSelection(): any {
		this.setState({
			modalForExportJob: !this.state.modalForExportJob,
		})
	}

	toggleBatchExportModalPopupOnSelection(): any {
		this.setState({
			modalForBatchExport: !this.state.modalForBatchExport,
		})
	}

	toggleModalForDeletion(): any {
		this.setState({
			modalForDelete: !this.state.modalForDelete,
		})
	}

	toggleModalPopupOnSubmissionOfrequest(): any {
		this.setState({
			modalForFinalMessage: !this.state.modalForFinalMessage,
		})
	}

	triggerEventBasedOnTransactionCount(row: ICoverageDiscoveryBatchHistoryGrid): void {
		if (row.batchData.totalTransactionsCount - row.batchData.pendingTransactionsCount - row.batchData.processingTransactionsCount > SettingsManager.COVERAGE_DISCOVERY_TRANSACTION_EXPORT_LIMIT) {
			this.setState({
				modalForExportJob: true,
				batchRunIdForExportJobModal: row.batchRunId,
				batchNameForExportJobModal: row.batchData.batchName,
			})
		} else {
			this.setState({
				modalForBatchExport: true,
			})
			this.onExportToExcel(row.batchRunId, row.batchData.batchName)
		}
		this.setState({
			showDeleteSuccessMessage: false,
		})
	}

	deleteRecord(row: ICoverageDiscoveryBatchHistoryGrid): any {
		this.setState({
			modalForDelete: true,
			requestDateForDeleteModal: row.runDate.toString().split('T')[0],
			batchNameForDeleteModal: row.batchData.batchName,
			selectedBatchIdForDelete: row.batchId,
			selectedBatchRunIdForDelete: row.batchRunId,
		})
	}

	confirmDeletion(): any {
		this.setState({
			showDeleteSuccessMessage: false,
		})
		this.props.BatchesStateManager.deleteSelectedRecord(this.state.selectedBatchIdForDelete, this.state.selectedBatchRunIdForDelete)
			.catch(error => {
				alert(error)
				console.log(error)
			})
			.then(() => {
				this.setState({ isDataLoading: true })
				this.props.BatchesStateManager.loadBatchHistoryGridResults().then(() => {
					this.setState({ isDataLoading: false })
				})
			})
			.then(() => {
				this.setState({
					showDeleteSuccessMessage: true,
					deleteSuccessMessage: 'Requested Batch has been deleted successfully!',
				})
			})
	}

	/*** To get Date string in the format of YYYYMMDDHHMMSS for file name*/
	getExportReportFileName(batchName: string): string {
		const dateString = moment(new Date()).format('YYYYMMDDHHmmss')
		return `${batchName}_${dateString}.xlsx`
	}

	sendBatchRunIdForBatchExportRequestJob(): any {
		const fileName = this.getExportReportFileName(this.state.batchNameForExportJobModal)
		this.props.BatchesStateManager.saveBatchRunIdForExportableJobs(fileName, this.state.batchRunIdForExportJobModal)
			.catch(error => {
				alert(error)
			})
			.then(() =>
				this.setState({
					modalForFinalMessage: this.props.BatchesStateManager.checkExportRequestSubmission,
				}),
			)
	}

	render(): React.ReactNode {
		const loadAllStatuses = (data: ICoverageDiscoveryBatchHistoryGridBatchData) => {
			return (
				<>
					{loadPendingStatus(data)}
					{loadProcessingStatus(data)}
					{loadCompleteStatus(data)}
					{loadErrorStatus(data)}
					{loadTimedOutStatus(data)}
				</>
			)
		}
		const loadPendingStatus = (data: ICoverageDiscoveryBatchHistoryGridBatchData) => {
			if (data.transactionStatusIds[0] === TransactionStatus.Pending) {
				if (data.pendingTransactionsCount > 0) {
					return <BatchInfo title="Pending" alt="Pending" source="img/icon-drop-pending.png" transactionCount={data.pendingTransactionsCount} />
				} else {
					return <BatchInfo title="Pending" alt="Pending" source="img/elig-status-pending-grey.png" transactionCount={0} />
				}
			}
			return null
		}
		const loadProcessingStatus = (data: ICoverageDiscoveryBatchHistoryGridBatchData) => {
			if (data.transactionStatusIds[4] === TransactionStatus.Processing) {
				if (data.processingTransactionsCount > 0) {
					return <BatchInfo title="Processing" alt="Processing" source="img/icon-drop-processing.png" transactionCount={data.processingTransactionsCount} />
				} else {
					return <BatchInfo title="Processing" alt="Processing" source="img/elig-status-processing-grey.png" transactionCount={0} />
				}
			}
			return null
		}
		const loadCompleteStatus = (data: ICoverageDiscoveryBatchHistoryGridBatchData) => {
			if (data.transactionStatusIds[1] === TransactionStatus.Complete) {
				if (data.completeTransactionsCount > 0) {
					return <BatchInfo title="Complete" alt="Complete" source="img/icon-drop-active.png" transactionCount={data.completeTransactionsCount} />
				} else {
					return <BatchInfo title="Complete" alt="Complete" source="img/elig-status-active-grey.png" transactionCount={0} />
				}
			}
			return null
		}
		const loadTimedOutStatus = (data: ICoverageDiscoveryBatchHistoryGridBatchData) => {
			if (data.transactionStatusIds[3] === TransactionStatus.TimedOut) {
				if (data.timedOutTransactionsCount > 0) {
					return <BatchInfo title="Timed Out" alt="Timed Out" source="img/icon-drop-missing.png" transactionCount={data.timedOutTransactionsCount} />
				} else {
					return <BatchInfo title="Timed Out" alt="Timed Out" source="img/elig-status-missing-grey.png" transactionCount={0} />
				}
			}
			return null
		}
		const loadErrorStatus = (data: ICoverageDiscoveryBatchHistoryGridBatchData) => {
			if (data.transactionStatusIds[2] === TransactionStatus.Error) {
				if (data.errorTransactionsCount > 0) {
					return <BatchInfo title="Error" alt="Error" source="img/icon-drop-failed.png" transactionCount={data.errorTransactionsCount} />
				} else {
					return <BatchInfo title="Error" alt="Error" source="img/elig-status-failed-grey.png" transactionCount={0} />
				}
			}
			return null
		}

		if (this.state.IsPageLoading) {
			return (
				<div>
					<TopPart pagesource="batches" />
					<div className="row tab-content">
						<div className="spinnerPage">
							<Spinner animation="border" role="status" />
						</div>
					</div>
				</div>
			)
		} else {
			return (
				<div>
					{this.state.isSearching && window.scrollTo(0, 0)}
					<TopPart pagesource="batches" />
					<div className="row  tab-content">
						<div className="width100P">
							<div className="contentBody">
								<div>
									{this.state.showDeleteSuccessMessage && window.scrollTo(0, 0)}
									<ValidationMessage showValidationMessage={this.state.showDeleteSuccessMessage} MessageType={MessageTypes.Success} validationMessage={this.state.deleteSuccessMessage} toggleAction={this.toggleValidationMessageForDelete} />
								</div>
								{this.renderImportBatchUI()}
								<Modal modalClassName="mdlForExportRequestForBatches" isOpen={this.state.modalForExportJob} fade={this.state.fadeForExportJobModal} toggle={(): void => this.toggleModalPopupOnSelection()} id="modalForfilterHistory">
									<h3 id="headingForExportRequestModalFOrBatches">Insurance Discovery Export Request</h3>
									<ModalBody>
										<Form>
											<Row>You have selected more than {SettingsManager.COVERAGE_DISCOVERY_TRANSACTION_EXPORT_LIMIT} transactions for export. Your request will be processed by the system and you will be able to download the report on completion of this request.</Row>
											<Row>Are you sure you want to continue?</Row>
										</Form>
									</ModalBody>
									<ModalFooter>
										<Button
											id="btnSubmit"
											onClick={(): void => {
												this.sendBatchRunIdForBatchExportRequestJob()
												this.toggleModalPopupOnSelection()
											}}
										>
											Yes
										</Button>{' '}
										<Button id="btnCancel" onClick={(): void => this.toggleModalPopupOnSelection()}>
											No
										</Button>
									</ModalFooter>
								</Modal>
								<Modal modalClassName="mdlForExportRequestForBatches" isOpen={this.state.modalForFinalMessage} fade={this.state.fadeForFinalMessage} toggle={(): void => this.toggleModalPopupOnSubmissionOfrequest()} id="modalForfilterHistory">
									<h3 id="headingForExportRequestModalFOrBatches">Insurance Discovery Export Request</h3>
									<ModalBody>
										<Form>
											<Row>
												<Label>Your request has been successfully submitted. </Label>
											</Row>
											<Row>You can retrieve the report by clicking the "View Reports (Exported Requests)" button on the History page, once it is available.</Row>
										</Form>
									</ModalBody>
									<ModalFooter>
										<Button id="btnSubmit" onClick={(): void => this.toggleModalPopupOnSubmissionOfrequest()}>
											OK
										</Button>
									</ModalFooter>
								</Modal>
								<Modal modalClassName="mdlForExportRequestForBatches" isOpen={this.state.modalForDelete} fade={this.state.fadeForDelete} toggle={(): void => this.toggleModalForDeletion()} id="modalForfilterHistory">
									<ModalHeader>
										<span
											id="closeModalForDeletion"
											onClick={(): void => {
												this.toggleModalForDeletion()
												this.setState({
													selectedBatchIdForDelete: 0,
													selectedBatchRunIdForDelete: 0,
												})
											}}
										>
											&times;
										</span>
									</ModalHeader>
									<h3 id="headingForExportDeleteModalFOrBatches">Confirm Delete</h3>
									<ModalBody>
										<Form>
											<Row>
												<Label>
													Are you sure you want to delete this occurrence of the executed batch "{this.state.batchNameForDeleteModal}" run at "{this.state.requestDateForDeleteModal}"?
												</Label>
											</Row>
										</Form>
									</ModalBody>
									<ModalFooter>
										<Button
											id="btnSubmit"
											onClick={(): void => {
												this.confirmDeletion()
												this.toggleModalForDeletion()
											}}
										>
											DELETE
										</Button>{' '}
										<Button
											id="btnCancel"
											onClick={(): void => {
												this.toggleModalForDeletion()
												this.setState({
													selectedBatchIdForDelete: 0,
													selectedBatchRunIdForDelete: 0,
												})
											}}
										>
											CANCEL
										</Button>
									</ModalFooter>
								</Modal>
								<Modal modalClassName="mdlForExportRequestForBatches" isOpen={this.state.modalForBatchExport} fade={this.state.fadeForBatchExport} toggle={(): void => this.toggleBatchExportModalPopupOnSelection()} id="modalForBatchExportRequest">
									<h3 id="headingForExportRequestModal">Insurance Discovery Export Request</h3>
									<ModalBody>
										<Form>
											<Row>Your request has been submitted. Your file will download when the report is ready. This may take some time.</Row>
										</Form>
									</ModalBody>
									<ModalFooter>
										<Button id="btnCancelForExportRequest" onClick={(): void => this.toggleBatchExportModalPopupOnSelection()}>
											Ok
										</Button>
									</ModalFooter>
								</Modal>
								<div className="row">
									<div id="divForFilters">
										{this.renderOwner()}
										{this.renderStatus()}
										{this.renderTransactionDate()}
										<Button className={this.state.isDataLoading ? 'disabled' : ''} id="btnFilterForBatches" onClick={(): Promise<void> => this.handleSearch()}>
											Filter
										</Button>{' '}
										{this.showOrHideClearAll()}
									</div>

									<div id="divForBatchesTable">
										<PaginationProvider
											pagination={paginationFactory({
												custom: true,
												page: this.props.BatchesStateManager.batchHistoryGridCriteria.page,
												sizePerPage: this.props.BatchesStateManager.batchHistoryGridCriteria.sizePerPage,
												totalSize: this.props.BatchesStateManager.batchHistoryGridResults.total,
												showTotal: true,
												sizePerPageList: [
													{
														text: '10',
														value: 10,
													},
													{
														text: '25',
														value: 25,
													},
													{
														text: '50',
														value: 50,
													},
													{
														text: '100',
														value: 100,
													},
												],
												paginationTotalRenderer: (from: number, to: number, size: number) => (
													<span className="react-bootstrap-table-pagination-total">
														{' '}
														Showing {from} to {to} of {size} Results{' '}
													</span>
												),
											})}
										>
											{({ paginationProps, paginationTableProps }: any): any => {
												return (
													<div>
														<div id="tableStyleForBatches">
															<span className={this.state.isDataLoading ? 'float-left disabled' : 'float-left'} id="showPageForBatches">
																<SizePerPageDropdownStandalone {...paginationProps} />
															</span>
															<span id="pageForBatch">
																<PaginationTotalStandalone {...paginationProps} />
															</span>
															<span className={this.state.isDataLoading ? 'float-right disabled' : 'float-right'}>
																<PaginationListStandalone {...paginationProps} />
															</span>
														</div>
														<Observer>
															{(): any => (
																<BootstrapTable
																	id="batchesTable"
																	keyField="batchId"
																	classes="dataTable"
																	loading={this.state.isDataLoading && !this.props.BatchesStateManager.isDataLoadingForInterval}
																	bootstrap4
																	hover
																	condensed
																	remote
																	noDataIndication={(): any => <this.NoDataIndication />}
																	onTableChange={(type: string, args: TableChangeState): void => this.handleTableChange(type, args)}
																	overlay={overlayFactory({
																		spinner: true,
																		styles: {
																			spinner: (base: any) => ({
																				...base,
																				margin: `0px auto ${this.spinnerHeight}px auto !important`,
																				'& svg circle': {
																					stroke: 'rgba(122, 122, 122,1)',
																				},
																			}),
																			overlay: (base: any) => ({
																				...base,
																				background: 'rgba(243, 242, 239,0.5)',
																				'margin-top': '2px !important',
																				height: this.tableHeight + 'px !important',
																			}),
																		},
																	})}
																	data={this.props.BatchesStateManager.batchHistoryGridResults.items.slice()}
																	defaultSorted={[
																		{
																			dataField: this.props.BatchesStateManager.batchHistoryGridCriteria.sortField,
																			order: this.props.BatchesStateManager.batchHistoryGridCriteria.sortOrder,
																		},
																	]}
																	filter={filterFactory()}
																	{...paginationTableProps}
																	columns={[
																		{
																			dataField: 'runDate',
																			text: 'Run Date',
																			sort: true,
																			headerStyle: (): any => {
																				return { width: '10%' }
																			},
																			formatter: (cell: JSX.Element, row: ICoverageDiscoveryBatchHistoryGrid): JSX.Element => {
																				return <Moment format="MM/DD/YYYY">{row.runDate}</Moment>
																			},
																		},
																		{
																			dataField: 'batchData',
																			text: 'Batch',
																			sort: true,
																			headerStyle: (): any => {
																				return { width: '41%' }
																			},
																			formatter: (cell: JSX.Element, row: ICoverageDiscoveryBatchHistoryGrid): JSX.Element => {
																				return (
																					<div id="requestDataForName">
																						<Row>
																							<Col>{row.batchData.batchName}</Col>
																							{row.batchRunStatusId !== BatchRunStatus.Error && row.batchRunStatusId !== BatchRunStatus.New && (
																								<Col>
																									<div style={{ marginLeft: '20px' }}>{row.batchData.totalTransactionsCount} transactions</div>
																									{row.batchData.coverageFoundCount > 0 && (
																										<div style={{ marginLeft: '20px' }} className="coverageCount">
																											{row.batchData.coverageFoundCount} with coverage
																										</div>
																									)}
																								</Col>
																							)}
																						</Row>
																						{row.batchRunStatusId !== BatchRunStatus.New && row.batchRunStatusId !== BatchRunStatus.Error && <Row>{row.batchData.transactionStatusIds && row.batchData.transactionStatusIds.length !== 0 ? loadAllStatuses(row.batchData) : ''}</Row>}
																						{row.batchRunStatusId === BatchRunStatus.New && (
																							<Row>
																								<Label>Your batch import request has been queued. You can view progress here once it starts processing.</Label>
																							</Row>
																						)}
																						{row.batchRunStatusId === BatchRunStatus.Error && (
																							<Row>
																								<Label style={{ color: 'red' }}>An unexpected error occurred while processing your batch. Please try again or contact administrator.</Label>
																							</Row>
																						)}
																					</div>
																				)
																			},
																		},
																		{
																			dataField: 'ownerName',
																			text: 'Owner',
																			sort: true,
																			headerStyle: (): any => {
																				return { width: '10%' }
																			},
																		},

																		{
																			dataField: 'batchId',
																			text: '',
																			sort: false,
																			headerStyle: (): any => {
																				return { width: '8%' }
																			},
																			formatter: (cell: JSX.Element, row: ICoverageDiscoveryBatchHistoryGrid): JSX.Element => {
																				return row.batchRunId !== null && typeof row.batchRunId !== 'undefined' ? (
																					<div>
																						{row.batchRunStatusId !== BatchRunStatus.New && row.batchRunStatusId !== BatchRunStatus.Error && (
																							<div>
																								{' '}
																								<Link to={`/requesthistory/${row.batchRunId}`}>RESULTS</Link>
																							</div>
																						)}
																						{row.batchData.totalTransactionsCount - row.batchData.pendingTransactionsCount > 0 && (
																							<div style={{ marginTop: '10px' }}>
																								<span id="batchLinks" onClick={(): void => this.triggerEventBasedOnTransactionCount(row)}>
																									EXPORT
																								</span>
																							</div>
																						)}
																						<div style={{ marginTop: '10px' }}>
																							<span id="batchLinks" onClick={(): void => this.deleteRecord(row)}>
																								DELETE
																							</span>
																						</div>
																					</div>
																				) : (
																					<div></div>
																				)
																			},
																		},
																	]}
																/>
															)}
														</Observer>
														<br />
													</div>
												)
											}}
										</PaginationProvider>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
	}
}
export const BatchesConnected = (): any => {
	const BatchesStateManager = container.get<IBatchesStateManager>('IBatchesStateManager')
	const userSessionStateManager = container.get<IUserSessionStateManager>('IUserSessionStateManager')
	const ImportBatchUIStateManager = container.get<IImportBatchUIStateManager>('IImportBatchUIStateManager')
	return <Route path="/Batches" render={(props): any => <Batches {...props} ImportBatchUIStateManager={ImportBatchUIStateManager} BatchesStateManager={BatchesStateManager} usersessionStateManager={userSessionStateManager} />} />
}
